import { useEffect, useState } from "react";
import { apiClient } from "../lib/apiClient";

// OwnerPortfolio mirrors the backend repositories.OwnerPortfolio — counts only,
// no owner name or contact data (owner identity stays Pro-gated in the leads view).
export interface OwnerPortfolio {
  totalTracked: number; // other tracked properties with the same owner, same county
  inForeclosure: number; // of those, still in a non-terminal stage
  // Of totalTracked, how many ALSO share this property's normalized mailing
  // address (#967, #2324) — a corroborating signal on top of the name match,
  // never an independent one (a shared mailing address alone is frequently a
  // shared mortgage-servicer lockbox, not shared ownership).
  mailingCorroborated: number;
}

// useOwnerPortfolio lazily fetches the owner-portfolio rollup for a property
// (GET /properties/:id/owner-portfolio). Returns null until loaded or when the
// owner is unknown / owns no other tracked parcel. Public endpoint — works for
// logged-out users, same as the property detail itself.
export function useOwnerPortfolio(propertyId: string | null) {
  const [portfolio, setPortfolio] = useState<OwnerPortfolio | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!propertyId) {
      setPortfolio(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    apiClient
      .get<OwnerPortfolio>(`/properties/${propertyId}/owner-portfolio`)
      .then(({ data }) => {
        if (cancelled) return;
        setPortfolio(data);
      })
      .catch(() => {
        if (!cancelled) setPortfolio(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [propertyId]);

  return { portfolio, loading };
}
